<template>
  <Modal
    fullscreen
    :active.sync="modalAtivo"
    :title="`Histórico do boleto - ${identificacaoBoleto}`"
    @close="fecharModal"
    id="popup-personalizado"
  >
    <div class="tab">
      <div :class="`tabs ${getActiveTabClass(1)}`" @click="changeActiveTab(1)">
        <span class="font-bold">Histórico de Emissões</span>
      </div>
      <div :class="`tabs ${getActiveTabClass(2)}`" @click="changeActiveTab(2)">
        <span class="font-bold">Ocorrências no Boleto</span>
      </div>
      <div :class="`tabs ${getActiveTabClass(3)}`" @click="changeActiveTab(3)">
        <span class="font-bold">Alterações no Boleto</span>
      </div>
    </div>

    <div class="mt-8" v-if="getActiveTab === 1">
      <div
        class="flex flex-col mb-4"
        v-for="(item, index) in historicoEmissoesBoleto"
        :key="index"
      >
        <span class="font-bold dataColor mb-2">Data {{ item.data }}</span
        ><span class="font-bold labelColor mb-2">Histórico de Emissões</span>
        <div
          class="grid grid-cols-2 xl:grid-cols-10 md:grid-cols-5 borda mb-2"
          v-for="(itemDados, indexDados) in item.dados"
          :key="indexDados"
        >
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Formato</span
            ><span class="labelColor p-2">{{ itemDados.formato }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Vencimento</span
            ><span class="labelColor p-2">
              {{
                functions.formataDataMomentJS(
                  itemDados.vencimento,
                  undefined,
                  6,
                )
              }}</span
            >
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Mês Referente</span
            ><span class="labelColor p-2">{{ itemDados.mesReferencia }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Valor</span
            ><span class="labelColor p-2">{{
              functions.formataReal(itemDados.valor)
            }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Banco</span
            ><span class="labelColor p-2">{{ itemDados.banco }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Tipo</span
            ><span class="labelColor p-2">{{ itemDados.tipo }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Considerar Fechamento</span
            ><span class="labelColor p-2">{{
              itemDados.considerarFechamento
            }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Usuário</span
            ><span class="labelColor p-2">{{
              (itemDados.usuarioAlteracao && itemDados.usuarioAlteracao.nome) ||
              'Sistema BP Tech'
            }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Dia</span
            ><span class="labelColor p-2">{{
              functions.formataDataMomentJS(itemDados.createdAt)
            }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Hora</span
            ><span class="labelColor p-2">{{
              functions.pegarHora(itemDados.createdAt)
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8" v-if="getActiveTab === 2">
      <div
        v-for="(item, index) in historicoOcorrenciasBoleto"
        :key="index"
        class="flex flex-col mb-4"
      >
        <span class="font-bold dataColor mb-2">Data {{ item.data }} </span
        ><span class="font-bold labelColor mb-2"
          >Histórico de Ocorrência (Remessa e Retorno)</span
        >
        <div
          class="grid grid-cols-2 xl:grid-cols-6 borda mb-2"
          v-for="(itemDados, indexDados) in item.dados"
          :key="indexDados"
        >
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Lote</span
            ><span class="labelColor p-2">{{
              itemDados.lote || 'Não gerado'
            }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Nosso Número</span
            ><span class="labelColor p-2">{{ itemDados.nossoNumero }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2"
              >Data de Geração do Arquivo</span
            ><span class="labelColor p-2">{{
              //POG
              functions.formataDataMomentJS(
                itemDados.dataGeracaoArquivo,
                'DD/MM/YYYY HH:mm',
                3,
              )
            }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Ocorrência</span
            ><span class="labelColor p-2">{{ itemDados.ocorrencia }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Valor</span
            ><span class="labelColor p-2">{{
              functions.formataReal(itemDados.valor)
            }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Usuário</span
            ><span class="labelColor p-2">{{ itemDados.nome }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8" v-if="getActiveTab === 3">
      <div
        v-for="(item, index) in historicoAlteracoesBoleto"
        :key="index"
        class="flex flex-col mb-4"
      >
        <span class="font-bold dataColor mb-2">Data {{ item.data }}</span
        ><span class="font-bold labelColor mb-2">Alterações do Boleto</span>
        <div
          class="grid grid-cols-2 xl:grid-cols-5 md:grid-cols-3 borda mb-2"
          v-for="(itemDados, indexDados) in item.dados"
          :key="indexDados"
        >
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Usuário</span
            ><span class="labelColor p-2">{{ itemDados.nome }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Hora</span
            ><span class="labelColor p-2">{{
              functions.pegarHora(itemDados.createdAt)
            }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Campo</span
            ><span class="labelColor p-2">{{ itemDados.campo }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Valor Anterior</span
            ><span class="labelColor p-2">{{ itemDados.valorAnterior }}</span>
          </div>
          <div class="flex flex-col flex-grow">
            <span class="font-bold labelColor p-2">Valor Posterior</span
            ><span class="labelColor p-2">{{ itemDados.valorPosterior }}</span>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import service from '../../services';
import Modal from '../../components/Modal.vue';

export default {
  name: 'historico-alteracoes-boleto',
  components: { Modal },
  props: ['popupActive', 'dadosConsulta'],
  data() {
    return {
      functions,
      historicoEmissoesBoleto: [],
      historicoOcorrenciasBoleto: [],
      historicoAlteracoesBoleto: [],
      modalAtivo: false,
      activeTab: 1,
    };
  },
  watch: {
    popupActive() {
      if (this.popupActive) {
        this.buscarHistorico();
      }
    },
  },
  computed: {
    getActiveTab() {
      return this.activeTab;
    },
    identificacaoBoleto() {
      const { id, ourNumber } = this.dadosConsulta;

      if (ourNumber) {
        return `NOSSO NÚMERO - ${ourNumber}`;
      } else {
        return `ID DO BOLETO - ${id}`;
      }
    },
  },
  methods: {
    changeActiveTab(active) {
      this.activeTab = active;
    },
    getActiveTabClass(active) {
      return this.activeTab === active ? 'activeTab' : '';
    },
    async buscarHistorico() {
      try {
        this.$vs.loading();
        const { insuredId, id, ourNumber } = this.dadosConsulta;
        const res = await service.getAll(
          'logs',
          null,
          `buscar-historico-boleto/${insuredId}/${id}/${ourNumber || 0}`,
        );

        if (res.data.length) {
          this.historicoBoleto = this.separarTiposHistorico(res.data);

          this.modalAtivo = true;
        } else {
          notify.notifyFail(this.$vs, 'Não há resgistro de alterações');
          this.$emit('close');
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        this.$emit('close');
      } finally {
        this.$vs.loading.close();
      }
    },
    separarTiposHistorico(historico) {
      const emissoes = historico.filter((h) => h.tipoHistorico === 'emissoes');
      const ocorrencias = historico.filter(
        (h) => h.tipoHistorico === 'ocorrencias',
      );
      const alteracoes = historico.filter(
        (h) => h.tipoHistorico === 'alteracoes',
      );

      this.historicoEmissoesBoleto = functions.organizarEmDias(emissoes);
      this.historicoOcorrenciasBoleto = functions.organizarEmDias(ocorrencias);
      this.historicoAlteracoesBoleto = functions.organizarEmDias(alteracoes);

      this.historicoAlteracoesBoleto = this.converteValoresMonetarios(
        this.historicoAlteracoesBoleto,
      );
    },
    converteValoresMonetarios(dados) {
      return dados.map((a) => {
        a.dados = a.dados.map((b) => {
          if (b.campo && b.campo.includes('valor')) {
            b.valorAnterior = functions.formataReal(+b.valorAnterior);
            b.valorPosterior = functions.formataReal(+b.valorPosterior);
          }
          return b;
        });
        return a;
      });
    },
    fecharModal() {
      this.$emit('close');
    },
  },
};
</script>
<style scoped>
.tab {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.tabs {
  position: relative;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  background: #ededed;
  color: #262626;
  padding: 1em 0 1em 0;
  cursor: pointer;
}
.activeTab {
  background: #008fcd;
  color: #ffffff;
}
.activeTab::after {
  content: '';
  position: absolute;
  bottom: -10px; /* Distância do triângulo em relação à tab */
  left: 50%;
  transform: translateX(-50%);
  border-style: solid;
  border-width: 10px 8px 0 8px;
  border-color: #3a91cf transparent transparent transparent;
  z-index: 1;
}
.dataColor {
  color: #114880;
}
.labelColor {
  color: black;
  font-weight: 500;
}
.borda {
  border: 0.2em solid #e7e7e7;
}
</style>
<style>
#popup-personalizado.con-vs-popup .vs-popup {
  width: 98% !important;
}
#popup-personalizado .vs-popup--header {
  background: #008fcd;
}
#popup-personalizado .vs-popup--header .vs-popup--title h3 {
  color: white;
}
</style>
